import { render } from "./add_new_vendor.vue?vue&type=template&id=7b367078"
import script from "./add_new_vendor.vue?vue&type=script&lang=js"
export * from "./add_new_vendor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__